import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const patentTypeApi = generateNomenApi(`/nomen/patent-type`);

export const patentTypeOptions = generateNomenOptions('patent-type', patentTypeApi);
